import React from "react";
import "./spinner.css";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-ball">
        <CircularProgress />
      </div>
    </div>
  );
};

export default Spinner;
